const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import { CountUp } from "../../../../lib/countUp";
import LvEffectComp from "./lv_effect_comp";

@ccclass
export  class PlayerEffectView extends ViewBase {
   
    @property(cc.Node)
    expItem:cc.Node = null;

    @property(cc.Node)
    lvItem:cc.Node = null;

    playeExpEffect(parent:cc.Node,data:any,finish?:Function){
        let json =JSON.parse(data.content);
        if (json) {
            let node = this.playEffect(this.expItem,parent,1.1,finish);
            let lab = node.getChildByName('effect_numb').getComponent(cc.Label);
            lab.string = json.incrExp;
        }
    }

    playerLvEffect(parent:cc.Node,data:any,finish?:Function){
        let json =JSON.parse(data.content);
        if (json != undefined) {
            let node = this.playEffect(this.lvItem,parent,3.6,finish);
            node.getComponent(LvEffectComp).initLvEffectComp(json);
        }
    }


    private playEffect(prefab:cc.Node,parent,delay:number,finish?:Function):cc.Node{
        let node = this.AddChild(prefab,parent);
        node.stopAllActions();
        let delayTime = cc.delayTime(delay);
        node.runAction(cc.sequence(delayTime,cc.callFunc(()=>{
            finish && finish();
            if (node != null && cc.isValid(node, true)) {
                node.destroy();
            }
        })));
        return node;
    }


    private AddChild(prefab:cc.Node,parent:cc.Node):cc.Node{
        if (parent === null || prefab === null) {
            cc.log('prefab or parent is null');
            return null;
        }
        let node = cc.instantiate(prefab);
        node.position = cc.Vec2.ZERO;
        node.angle = 0;
        node.scale = 1;
        node.active = true;
        parent.addChild(node);
        return node;
    }
}